import { FC } from 'react'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import Anchor from 'components/atoms/navigation/Anchor'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'
import styles from 'components/features/creditCard/creditCardPage/CardTermsPage/CardTermsPage.styl'
import cn from 'classnames'


export const CardTerms: FC<{ small?: boolean }> = (props) => (
  <article className={ cn(styles.article, { [styles.small]: !!props.small }) }>
    <h1>Status Money Consumer Credit Card Terms and Conditions</h1>
    <br />

    <b>IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT:</b> To help the government fight the funding of terrorism and
    money laundering activities, Federal law requires all financial institutions to obtain, verify and record information that identifies
    each person who opens an account. What this means for you: When you open an account, we will ask for your name, address, date of
    birth and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying
    documents.<br />
    <br />

    <b>
      We may change APRs, fees, and other Account terms in the future based on your experience with Evolve Bank & Trust and its
      affiliates as provided under the Cardmember Agreement and applicable law.
    </b><br />
    <br />

    We apply your minimum payment to balances with lower APRs first, including promotional APRs. Amounts paid over the minimum payment
    will be applied in the order of highest to lowest APR balances.<br />
    <br />

    <table>
      <tr>
        <th>Interest Rates and Interest Charges</th>
        <th>Status Money Consumer Credit Card</th>
      </tr>

      <tr>
        <td>
          <b>Annual Percentage Rate (APR) for Purchases</b>
        </td>
        <td>
          <span className={ styles.big }>15.99%</span> to <span className={ styles.big }>29.99%</span> when you open your account, based on your creditworthiness.<br /><br />
          After that, this APR will vary with the market based on the Prime Rate.
        </td>
      </tr>

      <tr>
        <td>
          <b>APR for Cash Advances</b>
        </td>
        <td>
          <b>29.99%</b><br /><br />
          This APR will vary with the market based on the Prime Rate.
        </td>
      </tr>

      <tr>
        <td>
          <b>Penalty APR and When it Applies</b>
        </td>
        <td>
          <b>29.99%</b><br /><br />
          This APR may be applied to your account if you fail to make a payment within 60 days of the date it is due.<br /><br />
          <b>How Long Will the Penalty APR Apply?</b> If your APRs are increased for this reason, the Penalty APR will apply until you make the next six consecutive minimum payments when due, or as otherwise required by law.
        </td>
      </tr>

      <tr>
        <td>
          <b>How to Avoid Paying Interest on Purchases</b>
        </td>
        <td>
          Your due date is at least 25 days after the close of each billing cycle. We will not charge you interest on purchases if you pay your entire balance by the due date each month.
        </td>
      </tr>

      <tr>
        <td>
          <b>Minimum Interest Charge</b>
        </td>
        <td>
          None
        </td>
      </tr>

      <tr>
        <td>
          <b>For Credit Card Tips from the Consumer Financial Protection Bureau</b>
        </td>
        <td>
          <b>
            To learn more about factors to consider when applying for or using a credit card, visit the website of the Consumer
            Financial Protection Bureau at <a href='http://www.consumerfinance.gov/learnmore'>http://www.consumerfinance.gov/learnmore</a>
          </b>
        </td>
      </tr>

      <tr>
        <th>
          Fees
        </th>
        <th>
          Status Money Consumer Credit Card
        </th>
      </tr>

      <tr>
        <td>
          <b>Annual Fee</b>
          <ul>
            <li>Annual Membership Fee</li>
          </ul>
        </td>
        <td>
          <b>No Annual Fee</b>
        </td>
      </tr>

      <tr className={ styles.noBottomBorder }>
        <td>
          <b>Transaction Fees</b>
        </td>
        <td />
      </tr>

      <tr className={ cn(styles.noTopBorder, styles.noBottomBorder) }>
        <td>
          <ul>
            <li>Cash Advance<br /></li>
          </ul>
        </td>
        <td>
          Either <b>5%</b> of the amount of each advance or <b>$10</b>, whichever is greater.
        </td>
      </tr>

      <tr className={ styles.noTopBorder }>
        <td>
          <ul>
            <li>Foreign Transaction</li>
          </ul>
        </td>
        <td>
          <b>$0</b>
        </td>
      </tr>

      <tr className={ styles.noBottomBorder }>
        <td>
          <b>Penalty Fees</b>
        </td>
        <td />
      </tr>

      <tr className={ cn(styles.noTopBorder, styles.noBottomBorder) }>
        <td>
          <ul>
            <li>Late Payment<br /></li>
          </ul>
        </td>
        <td>
          Up to <b>$25</b>
        </td>
      </tr>

      <tr className={ styles.noTopBorder }>
        <td>
          <ul>
            <li>Returned Payment</li>
          </ul>
        </td>
        <td>
          Up to <b>$25</b>
        </td>
      </tr>

    </table>
    <br />

    <p>
      <b>How We Will Calculate Your Balance:</b> We use a method called 'average daily balance (including new purchases)'. See
      your Cardmember Agreement for more details.
    </p>
    <br />

    <b>Rush Card Fee:</b> We will charge you $20 if you request us to expedite mailing of a physical access device to you. You may
    obtain your card without incurring an additional expense if you do not request expedited mailing.<br /><br />

    The information about the costs of the card described in this application is accurate as of 12/2021. This information may have
    changed after this date. To find out what may have changed, call us at (844) 333-3110 (we accept relay calls) or write to us
    at 100 Redwood Shores Pkwy, Suite 100, Redwood City, CA 94065.<br /><br />

    <b>How Variable Interest Rates Are Determined:</b> Your interest rate is a variable rate and is determined by a combination of the
    Prime Rate (which may vary) added to a margin (which does not change). Because the Prime Rate may vary, your variable interest rate will go up or down if the Prime Rate changes. If you are granted an Account, the following rates on the Account are variable: Purchase Rate; Cash Advance Rate. More information is available in the Cardmember Agreement.<br /><br />

    <b>Notice to New York Residents:</b> You may contact the New York State Department of Financial Services by telephone
    at (800) 342-3736 or visit its website at <a href='https://www.dfs.ny.gov/' target='_blank'>www.dfs.ny.gov</a> for free information
    on comparative credit card rates, fees and interest-free periods.<br /><br />

    <b>Notice to California Residents:</b> An applicant, if married, may apply for a separate account. Applicants: (1) may, after
    credit approval, use the credit card account up to its credit limit; and (2) may be liable for amounts extended under the plan to
    any joint applicant. As required by law, you are hereby notified that a negative credit report reflecting on your credit record may
    be submitted to a credit reporting agency if you fail to fulfill the terms of your credit obligations.<br /><br />

    <b>Notice to Married Wisconsin Residents:</b> No provision of any marital property agreement, unilateral statement under
    section 766.59 of the Wisconsin statutes or court decree under section 766.70, adversely affects our interest unless we, prior to
    the time the credit is granted or an open-end credit plan is entered into, are furnished a copy of the agreement, decree or
    court order, or have actual knowledge of the adverse provision. IF YOU ARE A MARRIED WISCONSIN RESIDENT, CREDIT EXTENDED UNDER
    THIS ACCOUNT WILL BE INCURRED IN THE INTEREST OF YOUR MARRIAGE OR FAMILY.<br /><br />

    <b>Notice to Ohio Residents:</b> The Ohio laws against discrimination require that all creditors make credit equally available to
    all creditworthy customers, and that credit reporting agencies maintain separate credit histories on each individual upon
    request. The Ohio Civil Rights Commission administers compliance with this law.<br /><br />

    <b>Delaware and Oregon Residents:</b> Service charges not in excess of those permitted by law will be charged on the outstanding
    balances from month to month. You may pay more than the minimum payment due, up to your entire outstanding balance,
    at any time.<br /><br />

    <b>Illinois Residents:</b> No applicant may be denied a credit card on account of race, religion, national origin, ancestry,
    age (between 40 and 70), sex, marital status, physical or mental handicap unrelated to the ability to pay or unfavorable
    discharge from military service. The applicant may request the reason for rejection of his or her application for a credit
    card. No person needs to reapply for a credit card solely because of a change in marital status unless the change has caused a
    deterioration in the person's financial position. A person may hold a credit card in any name permitted by law that he or she
    regularly uses or is known by, so long as no fraud is intended thereby.<br /><br />

    <b>Kentucky Residents:</b> You may pay the unpaid balance of your account in whole or in part at any time.<br /><br />

    <b>Utah Residents:</b> As required by Utah law, you are hereby notified that a negative credit report reflecting on your credit
    record may be submitted to a credit reporting agency if you fail to fulfill the terms of your credit obligations.<br /><br />

    <b>IMPORTANT TERMS AND APPLICATION AGREEMENT</b><br /><br />

    Our Privacy Policy can be viewed at <a href='https://www.getevolved.com/privacy-policy/.' target='_blank'>https://www.getevolved.com/privacy-policy/.</a><br /><br />

    By submitting this application, you understand and agree that Evolve Bank & Trust ("we," "us" or "our"), as the creditor and issuer
    of your Account, will rely on the information provided here in making this credit decision, and you certify that such information
    is accurate and complete to the best of your knowledge. If we open an Account based on this Application, you will be individually
    liable for all authorized charges and for all fees referred to in the most recent Cardmember Agreement, which may be amended from
    time to time. We may request consumer credit reports about you for evaluating this Application and in the future for reviewing
    Account credit limits, for Account renewal, for servicing and collection purposes and for other legitimate purposes associated
    with your Account. Upon your request, we will inform you if a consumer report was requested and, if it was, provide you with the
    name and address of the consumer reporting agency that furnished the report. By providing us with a telephone number for a cellular
    phone or other wireless device, including a number that you later convert to a cellular number, you are expressly consenting to
    receiving communications—including but not limited to prerecorded or artificial voice message calls, text messages, and calls
    made by an automatic telephone dialing system—from us and our affiliates and agents at that number.<br /><br />

    This express consent applies to each such telephone number that you provide to us now or in the future and permits such calls
    for non-marketing purposes. Calls and messages may incur access fees from your cellular provider. By submitting this Application,
    you also agree that we may verify your employment, income, address and all other information provided with other creditors, credit
    reporting agencies, employers, third parties and through records maintained by federal and state agencies (including state motor
    vehicle departments) and waive any rights of confidentiality you may have in that information under applicable law. You agree
    that, in order to open and administer the Account that may be established as a result of this Application, we and the correspondent
    financial institution, Status Money, Inc. and RailsTech that solicited this Application may share certain information about you
    and your ongoing Account activity. By submitting this application, you certify that you read and understood the disclosures here
    and you agree to the terms of this Application.<br /><br />

    <div className={ styles.center }>
      Status Money is a financial technology company, not a bank. The Status Money credit card is issued by Evolve Bank & Trust,
      Member FDIC pursuant to a license from Visa®️ USA, Inc.Visa is a registered trademark of Visa USA, Inc.<br /><br />

      © 2021 Evolve Bank & Trust
    </div>

  </article>
)

export const CardTermsPage: FC = () => {
  return (
    <Anchor placement='credit-card-terms'>
      <PageMeta
        title='Credit Card Terms | Status Money'
      />
      <ExternalLayout
        type='advisor'
      >
        <CardTerms />
      </ExternalLayout>
    </Anchor>
  )
}

export default CardTermsPage
